module Common {
    // Apply Croatian locale + Monday start globally for bootstrap-datepicker
    (function () {
        var dp: any = ($.fn as any).datepicker;
        if (dp && dp.defaults) {
            dp.defaults.language = 'hr';
            dp.defaults.weekStart = 1;
        }
        if (dp && dp.dates && dp.dates.hr && !dp.dates.hr.clear) {
            dp.dates.hr.clear = 'Očisti';
        }
    })();

    // Fix Bootstrap 4 nested-modal stacking: by default every .modal and .modal-backdrop
    // shares the same z-index, so a modal opened from inside an already-open modal
    // (e.g. script preview opened from the "Potvrda generiranja" popup) renders behind it.
    (function () {
        $(document).on('show.bs.modal', '.modal', function () {
            var zIndex = 1050 + (10 * $('.modal.show').length);
            $(this).css('z-index', zIndex);
            setTimeout(function () {
                $('.modal-backdrop:not([data-stacked])').css('z-index', zIndex - 1).attr('data-stacked', 'true');
            }, 0);
        });
    })();

    export interface AjaxResponse {
        Success: boolean,
        Response: string
    }

    export function FormatDate(date: string, type: string) {

        var formatedDate = "";

        if (type == "eu") {
            var dateObject: string[] = date.split('-');
            var year: string = dateObject[0];
            var month: string = dateObject[1];
            var day: string = dateObject[2];

            formatedDate = day + "." + month + "." + year;
        }
        else if (type == "js") {
            var dateObject: string[] = date.split('.');
            var year: string = dateObject[2];
            var month: string = dateObject[1];
            var day: string = dateObject[0];

            formatedDate = month + "/" + day + "/" + year;
        }
        else {
            var dateObject: string[] = date.split('.');
            var day: string = dateObject[0];
            var month: string = dateObject[1];
            var year: string = dateObject[2];

            formatedDate = year + "-" + month + "-" + day;
        }

        return formatedDate;
    }

    export function AddLeadingZero(value: string | number): string {
        let str = value.toString();
        return str.length === 1 ? "0" + str : str;
    }

    export function IsNumber(value: any): boolean {
        return value !== null && value !== '' && !isNaN(Number(value));
    }

    export function FormatDateNew(dateStr: string, format: string): string {
        const isoPattern = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
        let day: string;
        let month: string;
        let year: string;
        let hour: string;
        let minute: string;
        let second: string;

        //Ako dode ISO format onda uzmi iz objekta inace malo prekopaj i poslozi
        if (isoPattern.test(dateStr)) {
            const dateObj = new Date(dateStr);

            day = AddLeadingZero(dateObj.getDate().toString());
            month = AddLeadingZero((dateObj.getMonth() + 1).toString());
            year = dateObj.getFullYear().toString();
            hour = AddLeadingZero(dateObj.getHours().toString());
            minute = AddLeadingZero(dateObj.getMinutes().toString());
            second = AddLeadingZero(dateObj.getSeconds().toString());
        }
        else {
            [day, month, year, hour = "00", minute = "00", second = "00"] = dateStr.split(/[.\-/:\s]/);

            day = AddLeadingZero(day);
            month = AddLeadingZero(month);
            hour = AddLeadingZero(hour);
            minute = AddLeadingZero(minute);
            second = AddLeadingZero(second);
        }

        const isoString = `${year}-${month}-${day}T${hour}:${minute}:${second}`;

        return format.replace("YYYY", year).replace("MM", month).replace("DD", day).replace("HH", hour).replace("mm", minute).replace("ss", second).replace("ISO", isoString);
    }

    export function SetFileData(file: HTMLInputElement, fileName: string) {
        var fileUpload = file.files[0];
        var fileData = new FormData();

        fileData.set('script', fileUpload, fileName);

        return fileData;
    }

    export module Spinner {
        /** Full-block loading indicator (for modals, panels, etc.) */
        export function html(text: string = 'Učitavanje...'): string {
            return '<div class="text-center py-4"><span class="dt-css-spinner"></span>'
                 + '<div style="margin-top:10px;font-size:13px;color:#667085;">' + text + '</div></div>';
        }

        /** Single-row loading indicator for DataTable tbody */
        export function rowHtml(): string {
            return '<tr class="dt-loading-row"><td colspan="999" style="text-align:center;padding:32px 0;">'
                 + '<span class="dt-css-spinner"></span><br>'
                 + '<span class="dt-loading-text">Učitavanje...</span></td></tr>';
        }
    }

    export module AIService {
        export function GetAIResponse(downloadScript: boolean, scriptFile: any, appVersion: string = '', fileName: string = '') {
            Dialog.InfoDialog('AI Analiza', '');

            let $body = $('#InfoModalBody');
            let $status = $('#InfoModalSpan');

            $body.html('');
            $status.html('<i class="fas fa-spinner fa-spin"></i> Obrada u tijeku...');

            PlsWait.ShowLoader(false);

            var ajaxParams: JQueryAjaxSettings = {};

            if (!downloadScript) {
                var file = Common.SetFileData(scriptFile, "AI");
                ajaxParams.url = '/AIScript/PrepareScript';
                ajaxParams.contentType = false;
                ajaxParams.processData = false;
                ajaxParams.data = file;
            }
            else {
                ajaxParams.url = `/AIScript/SaveFileToCache/${appVersion}/${fileName}`;
                ajaxParams.contentType = 'application/json';
                ajaxParams.traditional = true;
            }

            ajaxParams.type = 'POST';
            ajaxParams.success = (result) => {

                let eventSource = new EventSource(`/AIScript/AIAgentStreaming/${result}`);
                let buffer = "";

                // Close the stream when the modal is dismissed
                $('#InfoModal').one('hidden.bs.modal', function () {
                    eventSource.close();
                });

                let statusTranslations: { [key: string]: string } = {
                    RunCreated: "Obrada je kreirana",
                    RunQueued: "U redu čekanja...",
                    RunInProgress: "Analiziram skriptu...",
                    RunStepCreated: "Korak obrade je kreiran",
                    RunStepInProgress: "Obrada koraka...",
                    MessageCreated: "Pripremam odgovor...",
                    MessageInProgress: "Pišem odgovor...",
                    MessageCompleted: "Poruka dovršena",
                    RunStepCompleted: "Korak dovršen",
                    RunCompleted: "Analiza završena"
                };

                eventSource.onmessage = function (event) {
                    let eventData = JSON.parse(event.data);
                    if (eventData.content) {
                        buffer += eventData.content;
                        $body.addClass('ai-streaming').html(buffer);
                        let $window = $body.closest('.ai-chat-window');
                        $window.scrollTop($window[0].scrollHeight);
                    } else {
                        let label = statusTranslations[eventData.updateKind] || eventData.updateKind;
                        if (eventData.updateKind === 'RunCompleted') {
                            $body.removeClass('ai-streaming');
                            $status.html('<i class="fas fa-check-circle" style="color:#1D9E75;"></i> ' + label);
                        } else {
                            $status.html('<i class="fas fa-spinner fa-spin" style="color:#378ADD;"></i> ' + label);
                        }
                    }
                };

                eventSource.onerror = function () {
                    eventSource.close();
                    $status.html('<i class="fas fa-exclamation-circle" style="color:#d92d20;"></i> Veza prekinuta');
                };
            };

            ajaxParams.error = (jqXHR, textStatus, errorThrown) => {
                let message = "Unknown error";
                if (jqXHR.responseText) {
                    try {
                        let json = JSON.parse(jqXHR.responseText);
                        message = json.message || jqXHR.responseText;
                    } catch (e) {
                        message = jqXHR.responseText;
                    }
                } else if (errorThrown) {
                    message = errorThrown;
                } else if (textStatus) {
                    message = textStatus;
                }

                console.log("Greška AJAX poziva:", message);
                $status.html('<i class="fas fa-exclamation-circle" style="color:#d92d20;"></i> Greška');
                Notifications.GetNotification(message, "danger");
                PlsWait.ShowLoader(false);
            };

            $.ajax(ajaxParams);
        }
    }

    export module DataTableCustom {
        export interface IColumns {
            data: string,
            title: string
        }

        export function Init(tableId: string, _dataTableSettings?: DataTables.Settings, _columnDefs?: DataTables.ColumnDefsSettings[], serverSideUrl?: string): void {

            var dataTableSettings: DataTables.Settings = {
                order: [[0, "desc"]],
                lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
                lengthChange: true,
                responsive: false,
                processing: false,
                stateSave: false,//true,
                autoWidth: false,
                scrollX: true,
                scrollY: '60vh',
                scrollCollapse: false,
                pageLength: 10,
                ...(_dataTableSettings)
            };

            if (serverSideUrl) {
                dataTableSettings.serverSide = true;
                dataTableSettings.deferRender = true;
                dataTableSettings.processing = true;
                dataTableSettings.searchDelay = 500;
                dataTableSettings.ajax = {
                    url: serverSideUrl,
                    type: 'GET',
                    dataSrc: 'data',
                    error: function (xhr: JQueryXHR, textStatus: string, errorThrown: string) {
                        let msg = errorThrown || textStatus || 'Nepoznata greška';
                        try {
                            const json = JSON.parse(xhr.responseText);
                            if (json && json.error) msg = json.error;
                        } catch (e) { /* ignore */ }
                        console.error(`DataTable Ajax error [${tableId}]:`, xhr.status, msg);
                        Notifications.GetNotification(msg, 'danger');
                    }
                };
            }

            const spinnerRow = () => Common.Spinner.rowHtml();

            dataTableSettings.preDrawCallback = function(this: any) {
                var $tbody = $("#" + tableId + " tbody");
                if (!$tbody.find(".dt-loading-row").length) {
                    $tbody.html(spinnerRow());
                }
            };

            dataTableSettings.language = {
                emptyTable: "Nema podataka u tablici",
                processing: "Učitavanje <i class='fad fa-circle-notch fa-spin'> </i>",
                lengthMenu: "Prikaz redaka: _MENU_ ",
                loadingRecords: "Učitavanje <i class='fad fa-circle-notch fa-spin'> </i>",
                zeroRecords: "Nije vraćen niti jedan record",
                info: "Prikazano _START_ do _END_ od _TOTAL_ redaka",
                decimal: ',',
                thousands: '.'
            };

            dataTableSettings.formatNumber = (format) => { return format.toLocaleString('hr-HR'); };

            // Provjera ako je kolona datum onda radi razliku između filtera i sortiranja
            if (dataTableSettings.columns) {
                dataTableSettings.columns = dataTableSettings.columns.map((col: any) => {
                    if (isDateColumn(col.title)) {
                        return {
                            ...col,
                            render: function (data: any, type: string) {
                                try {
                                    if (!data) return '';
                                    if (type === 'display' || type === 'filter') return data;
                                    if (!Common.FormatDateNew(data, 'ISO')) return data;
                                    return Common.FormatDateNew(data, 'ISO');
                                } catch (e) {
                                    return data;
                                }
                            }
                        };
                    }
                    return col;
                });
            }

            dataTableSettings.columnDefs = _columnDefs;

            // Discard saved state if column count has changed (prevents _fnCreateTr crash)
            dataTableSettings.stateLoadParams = function(settings: any, data: any) {
                var currentCols = $("#" + tableId + " thead th").length;
                if (data.columns && data.columns.length !== currentCols) {
                    return false;
                }
                // Strip saved column widths so DataTables always recalculates them fresh
                if (data.columns) {
                    data.columns.forEach(function(col: any) {
                        delete col.width;
                    });
                }
                // Do not restore saved page length or position — always start from page 1
                delete data.length;
                delete data.start;
            };

            // Adjust column widths after every draw (handles initial render + pagination + filter)
            dataTableSettings.drawCallback = function(this: any) {
                $("#" + tableId + " tbody .dt-loading-row").remove();
                this.api().columns.adjust();
            };

            var $tableElement: JQuery<HTMLElement> = $("#" + tableId);

            $tableElement.width("100%");
            $tableElement.addClass("table-hover");
            $tableElement.addClass("dt-responsive");
            $tableElement.addClass("table-highlight");

            var _table: any = $tableElement.DataTable(dataTableSettings);

            $(window).on('resize', function () {
                _table.columns.adjust();
            });
        }

        export function Destroy(tableId: string): void {
            var $tableElement: JQuery<HTMLElement> = $("#" + tableId);

            /*Provjera postoji li datatablica*/
            if ($.fn.dataTable.isDataTable($tableElement)) {
                $tableElement.DataTable().clear();
                $tableElement.DataTable().destroy();
                $tableElement.empty();
            }
        }

        export function ClearData(tableId: string): void {
            var $tableElement: JQuery<HTMLElement> = $("#" + tableId);

            if ($.fn.dataTable.isDataTable($tableElement)) {
                $tableElement.DataTable().clear();
                $tableElement.empty();
            }
        }

        export function RefreshTableData(tableId: string) {
            var $tableElement: JQuery<HTMLElement> = $("#" + tableId)

            if ($.fn.dataTable.isDataTable($tableElement)) {
                $tableElement.DataTable().ajax.reload(function () {
                    $tableElement.DataTable().columns.adjust();
                }, false);
            }
        }

        function isDateColumn(columnName: string): boolean {
            return /\b(date|datum|dat|time|vrijeme)\b/i.test(columnName);
        }
    }

    // ── FilterBar ──────────────────────────────────────────────────────────────
    // Common filter bar wiring. Reads #versionList, #companyList, optionally
    // #dateFrom / #dateTo and #environmentList, then calls onApply() whenever
    // the user clicks the apply button or changes a dropdown.
    //
    // Options:
    //   applyBtnId    – id of the "Primjeni" button  (default: "setFilters")
    //   watchSelects  – if true, fire onApply on every select change too (default: true)
    //   hasDates      – wire up dateFrom / dateTo change guards            (default: false)
    //   hasEnvironment– wire up #environmentList change                    (default: false)
    //   onEnvironmentChange – optional extra callback when environment changes
    // ──────────────────────────────────────────────────────────────────────────
    export module FilterBar {
        export interface Options {
            applyBtnId?: string;
            watchSelects?: boolean;
            hasDates?: boolean;
            onDateChange?: () => void;
            hasEnvironment?: boolean;
            onEnvironmentChange?: () => void;
        }

        export function BuildUrl(base: string, environment?: string): string {
            var versionId: string = ($("#versionList").val() || '').toString();
            var companyId: string = ($("#companyList").val() || '').toString();
            var url = `${base}?idVersion=${versionId}&idCompany=${companyId}`;

            var $dateFrom = $('#dateFrom');
            var $dateTo   = $('#dateTo');
            if ($dateFrom.length && $dateTo.length) {
                var dateFrom = Common.FormatDate($dateFrom.val().toString(), 'en');
                var dateTo   = Common.FormatDate($dateTo.val().toString(), 'en');
                url += `&dateFrom=${encodeURIComponent(dateFrom)}&dateTo=${encodeURIComponent(dateTo)}`;
            }

            if (environment) url += `&environment=${encodeURIComponent(environment)}`;
            return url;
        }

        export function Init(onApply: () => void, options?: Options): void {
            var opts: Required<Options> = {
                applyBtnId: 'setFilters',
                watchSelects: true,
                hasDates: false,
                onDateChange: null,
                hasEnvironment: false,
                onEnvironmentChange: null,
                ...(options || {})
            };

            $('#' + opts.applyBtnId).on('click', function () {
                onApply();
            });

            if (opts.watchSelects) {
                $('#versionList, #companyList').on('change', function () {
                    onApply();
                });
            }

            if (opts.hasDates) {
                $('#dateFrom').on('change', function () {
                    var df: Date = new Date(Common.FormatDate($('#dateFrom').val().toString(), 'js'));
                    var dt: Date = new Date(Common.FormatDate($('#dateTo').val().toString(), 'js'));
                    if (df >= dt) {
                        ($('#dateTo') as any).datepicker('update', $('#dateFrom').val().toString());
                    }
                    ($('#dateTo') as any).datepicker('setStartDate', df);
                    if (opts.onDateChange) opts.onDateChange();
                });

                $('#dateTo').on('change', function () {
                    if (opts.onDateChange) opts.onDateChange();
                });
            }

            if (opts.hasEnvironment) {
                $('#environmentList').on('change', function () {
                    if (opts.onEnvironmentChange) {
                        opts.onEnvironmentChange();
                    } else {
                        onApply();
                    }
                });
            }
        }
    }

    export module FileZone {
        var _droppedFile: File | null = null;

        export function GetDroppedFile(): File | null {
            return _droppedFile;
        }

        export function Init(fileInputId: string): void {
            _droppedFile = null;
            var skipNextClick = false;

            function applyFile(file: File): void {
                $('#spcFileName').text(file.name);
                var size = file.size >= 1024 * 1024
                    ? (file.size / (1024 * 1024)).toFixed(1) + ' MB'
                    : (file.size / 1024).toFixed(1) + ' KB';
                $('#spcFileHint').text(size);
                $('#spcFileZone').addClass('spc-file-zone--has-file');
                $('#spcBrowseBtn').text('Promijeni');
            }

            $('#spcFileZone').on('click', function () {
                if (skipNextClick) {
                    skipNextClick = false;
                    return;
                }
                $('#' + fileInputId).trigger('click');
            });

            $('#spcFileZone').on('dragover dragenter', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).addClass('spc-file-zone--drag');
            });

            $('#spcFileZone').on('dragleave dragend', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).removeClass('spc-file-zone--drag');
            });

            $('#spcFileZone').on('drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
                skipNextClick = true;
                $(this).removeClass('spc-file-zone--drag');
                var dt = e.originalEvent && (e.originalEvent as DragEvent).dataTransfer;
                var file = dt && dt.files && dt.files[0];
                if (file) {
                    _droppedFile = file;
                    applyFile(file);
                }
            });

            $('#' + fileInputId).on('change', function (this: HTMLInputElement) {
                var file = this.files && this.files[0];
                if (file) {
                    _droppedFile = null;
                    applyFile(file);
                }
            });
        }
    }

    export module TimelineManager {
        interface TimelineConfig {
            modalId: string;
            listId: string;
            compareBarId: string;
            titleId: string;
            compareButtonId: string;
        }

        interface TimelineEntry {
            idMetaData: number;
            idScript: number;
            scriptName: string;
            fileName: string;
            version: string;
            createDate: string;
            author: string;
            hasDiff: boolean;
            aiSummary: string;
            metaType: string;
            metaUser: string;
        }

        let config: TimelineConfig;
        let _timelineSelections: number[] = [];
    let _openedScriptId: string | null = null;

        export function Init(cfg: TimelineConfig): void {
            config = cfg;
            window['openTimeline'] = loadTimeline;
        }

        function renderTimeline(entries: TimelineEntry[]): void {
            const list = document.getElementById(config.listId);
            const compareBar = document.getElementById(config.compareBarId);
            
            if (!entries || entries.length === 0) {
                list.innerHTML = '<div class="timeline-empty">Nema pronađenih unosa.</div>';
                compareBar.classList.remove('visible');
                return;
            }

            const track = document.createElement('div');
            track.className = 'timeline-track';

            entries.forEach(function (e: TimelineEntry) {
                const entry = document.createElement('div');
                entry.className = 'timeline-entry';
                entry.dataset.idMetaData = e.idMetaData.toString();
                entry.dataset.idScript = e.idScript ? e.idScript.toString() : '';

                if (_openedScriptId !== null && String(e.idScript) === _openedScriptId) {
                    entry.classList.add('timeline-entry--opened');
                }

                const dateStr = e.createDate ? new Date(e.createDate).toLocaleDateString('hr-HR') : '—';
                const aiSnip = e.aiSummary
                    ? '<div class="timeline-card-ai">' + e.aiSummary.replace(/</g, '&lt;') + '</div>'
                    : '';
                const typeBadge = e.metaType
                    ? '<span style="font-size:10px;background:#f2f4f7;color:#344054;padding:2px 6px;border-radius:99px;">' + e.metaType + '</span>'
                    : '';

                entry.innerHTML =
                    '<div class="timeline-dot"></div>' +
                    '<div class="timeline-card">' +
                        '<div class="timeline-card-header">' +
                            '<span class="timeline-card-version">' + (e.version || '') + '</span>' +
                            typeBadge +
                            '<span class="timeline-card-date"><i class="fas fa-calendar-alt" style="font-size:10px;"></i> ' + dateStr + '</span>' +
                            '<span class="timeline-card-author"><i class="fas fa-user" style="font-size:10px;"></i> ' + (e.author || '—') + '</span>' +
                        '</div>' +
                        '<div class="timeline-card-body">' +
                            '<div class="timeline-card-script">' + (e.fileName || e.scriptName || '') + '</div>' +
                            aiSnip +
                        '</div>' +
                        '<div class="timeline-card-actions">' +
                            '<button class="timeline-diff-btn" data-id="' + e.idMetaData + '">Razlike <i class="fas fa-code-branch"></i></button>' +
                        '</div>' +
                    '</div>';

                entry.querySelector('.timeline-diff-btn').addEventListener('click', function () {
                    const id = parseInt((this as HTMLElement).getAttribute('data-id'));
                    $('#' + config.modalId).modal('hide');
                    Dialog.OpenModal('<i class="fas fa-exchange-alt" style="margin-right:6px;color:#378ADD;"></i>Razlike skripte', '', '/ScriptMetaData/DiffDetail/' + id, '', 'modal-xl');
                });

                entry.querySelector('.timeline-card').addEventListener('click', function (ev: Event) {
                    if ((ev.target as HTMLElement).closest('.timeline-diff-btn')) return;
                    const id = parseInt(entry.dataset.idMetaData);
                    const idx = _timelineSelections.indexOf(id);
                    if (idx === -1) {
                        if (_timelineSelections.length >= 2) return;
                        _timelineSelections.push(id);
                        entry.classList.add('timeline-entry--selected');
                    } else {
                        _timelineSelections.splice(idx, 1);
                        entry.classList.remove('timeline-entry--selected');
                    }
                    updateCompareBar();
                });

                track.appendChild(entry);
            });

            list.innerHTML = '';
            list.appendChild(track);
        }

        function updateCompareBar(): void {
            const bar = document.getElementById(config.compareBarId);
            const info = document.getElementById('timelineCompareInfo') as HTMLElement;
            const btn = document.getElementById(config.compareButtonId) as HTMLButtonElement;

            if (!info || !btn) return;

            if (_timelineSelections.length === 2) {
                bar.classList.add('visible');
                info.textContent = 'Usporedba: 2 odabrana unosa';
                btn.disabled = false;
            } else if (_timelineSelections.length === 1) {
                bar.classList.add('visible');
                info.textContent = 'Odaberi još 1 unos za usporedbu';
                btn.disabled = true;
            } else {
                bar.classList.remove('visible');
                btn.disabled = true;
            }
        }

        export function loadTimeline(metaName: string, metaType: string, metaUser: string, openedScriptId?: number | null): void {
            _timelineSelections = [];
            _openedScriptId = openedScriptId === null || openedScriptId === undefined ? null : String(openedScriptId);
            const list = document.getElementById(config.listId);
            const compareBar = document.getElementById(config.compareBarId);

            list.innerHTML = '<div class="timeline-empty"><i class="fas fa-spinner fa-spin"></i> Učitavanje...</div>';
            compareBar.classList.remove('visible');

            const titleParts = [metaType, metaUser].filter(Boolean);
            const subtitle = titleParts.length ? ' <span style="font-size:11px;font-weight:400;color:#667085;">(' + titleParts.join(' · ') + ')</span>' : '';
            const title = document.getElementById(config.titleId);
            if (title) title.innerHTML = metaName + subtitle;

            const url = '/ScriptMetaData/TimelineData?metaName=' + encodeURIComponent(metaName) +
                        '&metaType=' + encodeURIComponent(metaType) +
                        '&metaUser=' + encodeURIComponent(metaUser);

            fetch(url)
                .then(r => r.json())
                .then(renderTimeline)
                .catch(() => {
                    list.innerHTML = '<div class="timeline-empty" style="color:#B42318;">Greška pri učitavanju.</div>';
                });
        }

        export function compareSelected(): void {
            if (_timelineSelections.length !== 2) return;
            $('#' + config.modalId).modal('hide');
            Dialog.OpenModal('<i class="fas fa-code-branch" style="margin-right:6px;color:#5b21b6;"></i>Usporedba verzija', '', '/ScriptMetaData/DiffBetween/' + _timelineSelections[0] + '/' + _timelineSelections[1], '', 'modal-xl');
        }
    }
}